"use client"
import {
  PLAN_A_POWER,
  columnIdxAtOrBefore,
} from "../blocks/power/distribution-of-power-bubbles/planAPowerRegions"
import { METRIC_FORK_YEAR, type MetricScenarioSeries, type SeriesPoint } from "./metricDetailsTypes"

// Distribution of Power sampled from the SAME data the HUD's power bubbles
// draw: the power-distribution tab import (data/plan-a/powerDistribution.json).
// The metric is the largest single holder's share of world compute — the tab's
// rank rows ARE the individual holders (tails are ranks 21+, never a single
// holder), so the top share is simply the largest rank over the world stock.
// Annual points read the year's Jan-1 column, matching the treemap's stepping.
const shareAtYear = (year: number): number => {
  const { dates, regionStocks, ranks } = PLAN_A_POWER
  const idx = columnIdxAtOrBefore(dates, year)
  const world = regionStocks.US[idx] + regionStocks.CH[idx] + regionStocks.RoW[idx]
  const top = Math.max(0, ...ranks.map((rank) => rank.series[idx] ?? 0))
  return world > 0 ? top / world : 0
}

const buildPowerShareSeries = (): MetricScenarioSeries => {
  const annual = (from: number, to: number): SeriesPoint[] =>
    Array.from({ length: to - from + 1 }, (_, i) => {
      const year = from + i
      return { year, value: shareAtYear(year) }
    })
  return {
    // The tab starts at 2025; hold 2024 flat at the first reading, matching
    // how the other series treat their pre-data year.
    observed: [{ year: 2024, value: shareAtYear(2025) }, ...annual(2025, 2025)],
    projection: annual(2025, METRIC_FORK_YEAR),
    branches: {
      A: annual(METRIC_FORK_YEAR, 2040),
      D: [],
    },
  }
}

// Built lazily on first use — not at module load.
let staticSeries: MetricScenarioSeries | null = null
export const getStaticPowerShareSeries = (): MetricScenarioSeries =>
  (staticSeries ??= buildPowerShareSeries())

export const usePowerShareSeries = (): MetricScenarioSeries => getStaticPowerShareSeries()
